import React from "react";
import { Link } from "react-router-dom";
import Wrapper from "../../../UI/Wrapper/Wrapper";
import "./_Main.scss";

const products = [
  {
    id: "jazzys-burger",
    title: "Jazzy's Burger",
    body: "Restaurant ordering: apps, web, payments, and admin for a multi-location QSR brand in Nigeria.",
    caseStudy: "/caseStudy/jazzysburger",
    live: "https://jazzysburger.com",
  },
  {
    id: "eve-after-dark",
    title: "Eve After Dark",
    body: "Cloud kitchen ordering and operations across Nigeria and the UK.",
    caseStudy: "/caseStudy/ead",
    live: "https://theeveafterdark.co.uk",
  },
  {
    id: "awashop",
    title: "AwaShop",
    body: "Merchant storefronts, payments, and order management for small businesses.",
    live: "https://awashop.ng",
  },
  {
    id: "sendchops",
    title: "Sendchops",
    body: "Cross-border checkout and vendor tooling. Launching 2026.",
    live: "https://sendchops.com",
  },
];

const DeploymentsSection = () => {
  return (
    <div className="orderforge__deployments">
      <Wrapper>
        <div className="orderforge__deployments-inner">
          <span>
            <h6>Products</h6>
            <p>Live software Awa Digital builds and runs on this platform.</p>
          </span>
          {products.map((product) => (
            <article
              className="orderforge__deployment-card"
              id={product.id}
              key={product.id}
            >
              <h6>{product.title}</h6>
              <p>{product.body}</p>
              <div className="orderforge__deployment-links">
                {product.caseStudy && (
                  <Link to={product.caseStudy}>Case study</Link>
                )}
                <a href={product.live} target="_blank" rel="noreferrer">
                  Live site
                </a>
              </div>
            </article>
          ))}
        </div>
      </Wrapper>
    </div>
  );
};

export default DeploymentsSection;
